<template>
  <el-container>
    <!-- <el-header>
      <el-row :gutter="20">
        <el-col :span="4">
          <img class="logo" src="../assets/logo.png" alt="logo" />
        </el-col>
        <el-col :span="16">
          <div class="title">账单详情系统</div>
        </el-col>
        <el-col :span="4">
          <el-button type="primary">退出</el-button>
        </el-col>
      </el-row>
    </el-header> 
    <el-container>-->
      <!-- <el-aside width="200px">
        <el-menu router active-text-color="#ffd04b" background-color="#545c64" class="el-menu-vertical-demo"
          default-active="2" text-color="#fff">
          <el-menu-item v-for="i in niuList" :key="i.path" :index="i.path">
            <el-icon><icon-menu /></el-icon>
            <span>{{ i.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside> -->
      <el-container>
        <el-main>
          <router-view />
        </el-main>
        <!-- <el-footer>Footer</el-footer> -->
      </el-container>
    </el-container>
  <!-- </el-container> -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from "vue-router"


export default defineComponent({
  name: 'HomeView',
  components: {
  },
  setup() {
    const router = useRouter()
    const niuList = router.getRoutes().filter((route) => route.meta.isShow)
    // console.log(niuList)
    return { niuList }
  }

})

</script>


<style lang="scss" scoped>
.logo {
  width: 60px;
  height: 60px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: calc(100vh - 60px);
}
.el-main {
  min-height: calc(100vh - 60px);
  overflow-y: auto;
}
.el-header {
  background-color: #2c3d53;
  color: var(--el-text-color-primary);
  line-height: 60px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
}
</style>